import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import {
  AppearanceEntityInterface,
  AppearanceInterface,
} from 'src/shared/schemas/appearance'

export const useUpdateEntityAppearance = <T extends AppearanceEntityInterface>(
  entity: T,
) => {
  const updateEntity = useUpdateEntity<T>()
  return (appearance: AppearanceInterface) =>
    updateEntity({
      ...entity,
      appearance,
    })
}
